const sessionStorage = window.sessionStorage

export const setSessionStorage = (key, value) => {
  if (value instanceof Object) {
    value = JSON.stringify(value)
  }
  sessionStorage.setItem(key, value)
}

export const getSessionStorage = (key) => {
  let value = sessionStorage.getItem(key) || null
  try {
    value = JSON.parse(value)
  } catch (error) {}
  return value
}

export const removeSessionStorage = (key) => {
  sessionStorage.remove(key)
}

export const clearSessionStorage = () => {
  sessionStorage.clear()
}
